import { render } from "./DonutCard.vue?vue&type=template&id=23d875fe"
import script from "./DonutCard.vue?vue&type=script&lang=js"
export * from "./DonutCard.vue?vue&type=script&lang=js"

import "./DonutCard.vue?vue&type=style&index=0&id=23d875fe&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__